import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import breakpoints from '../../Theme/breakpoints';

const SideBarContainer = styled.section`
  display: block;

  @media (min-width: ${breakpoints.sm}px) {
    display: flex;
    flex-wrap: wrap;
  }

  @media (min-width: ${breakpoints.lg}px) {
    display: block;
  }
`;

const SidebarItem = styled.div`
  margin: 0 0 24px;

  &:last-of-type {
    margin: 0;
  }

  @media (min-width: ${breakpoints.sm}px) {
    flex-basis: calc(50% - (16px + 1px));
    border-right: 1px solid var(--grey-light);
    padding: 0 16px 0 0;
    margin: 0;

    &:first-of-type {
      flex-basis: calc(100%);
      border-right: none;
      padding: 0 0 16px;
      border-bottom: 1px solid var(--grey-light);
      margin: 0 0 16px;
    }

    &:last-of-type {
      border-right: none;

      @media(min-width: ${breakpoints.sm}px) {
        padding: 0 0 0 16px;
      }

      @media(min-width: ${breakpoints.lg}px) {
        padding: 0;
      }
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    border-right: none;

    &:first-of-type {
      border-bottom: none;
    }
  }
`;

const AdUnitSidebarItem = styled(SidebarItem)`
  @media (min-width: ${breakpoints.lg}px) {
    min-height: 298px;
  }
`;

const MostReadSidebarItem = styled(SidebarItem)`
  @media (min-width: ${breakpoints.lg}px) {  
    min-height: 632px;
  }
`;

const HighlightedJobsSidebarItem = styled(SidebarItem)`
  @media (min-width: ${breakpoints.lg}px) {  
    min-height: 263.5px;
  }
`;

const SideBar = ({
  adUnitItem,
  mostRead,
  highlightedJobs,
}) => (
  <SideBarContainer>
    {adUnitItem && (
    <AdUnitSidebarItem>
      {adUnitItem}
    </AdUnitSidebarItem>
    )}
    {mostRead && (
    <MostReadSidebarItem>
      {mostRead}
    </MostReadSidebarItem>
    )}
    {highlightedJobs && (
    <HighlightedJobsSidebarItem>
      {highlightedJobs}
    </HighlightedJobsSidebarItem>
    )}
  </SideBarContainer>
);
SideBar.propTypes = {
  adUnitItem: PropTypes.node,
  mostRead: PropTypes.node,
  highlightedJobs: PropTypes.node,
};

SideBar.defaultProps = {
  adUnitItem: undefined,
  mostRead: undefined,
  highlightedJobs: undefined,
};

export default SideBar;
